module.exports = __webpack_public_path__ + "static/pic-3@3x-2412f7d07e98c73bc770052549742075.png";